import Typography from '@/components/shared/typography/typography.component';
import { ImperfectionReportItem } from '@/types';
import Image from 'next/image';
import { CheckCircleGreenOutlined } from 'public/Images';
import { FC } from 'react';

const UnFultyImprefectionItem: FC<{
    item: ImperfectionReportItem;
    tags: string | null;
    IS_RTL: boolean;
}> = ({ item, tags, IS_RTL }) => {
    return (
        <div className="flex justify-between items-center gap-2">
            <div>
                <Typography variant="body2" className="!text-gray-700 w-max">
                    {IS_RTL ? item.name_ar : item.name_en}
                </Typography>
            </div>
            <div className="flex items-center gap-2.5 w-auto">
                {tags && (
                    <Typography
                        variant="caption"
                        className="!text-gray-600 w-[calc(100%-20px)]"
                    >
                        {tags}
                    </Typography>
                )}
                <Image src={CheckCircleGreenOutlined} alt="good" />
            </div>
        </div>
    );
};

export default UnFultyImprefectionItem;
